"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_device_detect_1 = require("react-device-detect");
/**
 * @desc [ iOS 브라우저 버그 대응 ]
 * iOS 환경에서 다이얼로그 열렸을 때 body 컴포넌트가 스크롤 되는 현상이 종종 있으므로,
 * 다이얼로그 닫힐 때 body의 원래 스크롤 위치 복원.
 * @tip body가 scrollable 하지 않거나, 다이얼로그가 작을 경우엔 사용 안해도 될듯함.
 */
function default_1(open) {
    // const reactWrapper = document.querySelector('#root') as HTMLDivElement;
    const body = document.body;
    const scrollPosition = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        if (react_device_detect_1.isIOS && open) {
            // reactWrapper.style.pointerEvents = 'none';
            scrollPosition.current = body.getBoundingClientRect().y;
            return () => {
                // reactWrapper.style.removeProperty('pointer-events');
                window.scrollTo(0, -scrollPosition.current);
            };
        }
    }, [open]);
}
exports.default = default_1;
